var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerifyAcc({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "verify_acc",
    transform: "translate(80 -8128)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2149",
    "data-name": "Rectangle 2149",
    width: 64,
    height: 64,
    transform: "translate(-80 8128)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "e5624d39b35c645fcb2dc242597966b6",
    transform: "translate(-77.942 8130.059)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2150",
    "data-name": "Rectangle 2150",
    width: 60,
    height: 60,
    rx: 5.917,
    transform: "translate(-0.058 -0.058)",
    fill: "#017f99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24627",
    "data-name": "Path 24627",
    d: "M29.963,7.5a5.355,5.355,0,1,0,5.34,5.355A5.355,5.355,0,0,0,29.963,7.5ZM20.345,9.547a12.874,12.874,0,0,0-9.53,21.5,12.541,12.541,0,0,1,5.375-3.657,6.407,6.407,0,0,1,7.682-10.244,7.447,7.447,0,0,1-.781-7.267,12.83,12.83,0,0,0-2.746-.329Zm11.615.663,1.512,1.516-4.307,4.316-2.712-2.718,1.512-1.514,1.2,1.2,2.8-2.8ZM20.27,18.151a4.28,4.28,0,0,0-.2,8.557c.053,0,.1-.015.158-.015s.118.013.18.013a4.279,4.279,0,0,0-.135-8.555Zm5.3.716A6.408,6.408,0,0,1,24.28,27.4a12.5,12.5,0,0,1,5.462,3.777,12.552,12.552,0,0,0,3.129-11.442,7.408,7.408,0,0,1-7.3-.866Zm-5.507,9.981A10.356,10.356,0,0,0,12.346,32.5a12.767,12.767,0,0,0,15.839.1A10.319,10.319,0,0,0,20.4,28.848c-.047,0-.086.013-.135.013h-.053c-.051,0-.1-.013-.15-.013Z",
    transform: "translate(8.54 8.54)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerifyAcc);
export default __webpack_public_path__ + "static/media/verify_acc.c32ee8fc00919f1ae79464473faacb2f.svg";
export { ForwardRef as ReactComponent };